import useDhDeliveryKpiType, {
  IDataType as IDhDeliveryKpiType,
} from './useDeliveryKpiType'

export type IVariablesType = 'dhDeliveryKpiType'
export type IDataType = IDhDeliveryKpiType

export const hooks = [['dhDeliveryKpiType', useDhDeliveryKpiType]] as const
